import Vue from 'vue'
import News from '../vue/news.vue'
import Stickyfill from 'stickyfill'
import 'promise-polyfill/src/polyfill';

export default {
  init() {
    // JavaScript to be fired on the home page

    new Vue({
      el: "#news-grid",
      components: {
        News,
      },
    });

    let stickyElements = document.querySelectorAll('.sticky');

    for (var i = stickyElements.length - 1; i >= 0; i--) {
      Stickyfill.add(stickyElements[i]);
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/post-type-archive-news.js